import React, { useState } from 'react';
import moment from 'moment';
import parse from 'html-react-parser';

import { config } from '../../../config/index';

import { toWeekInt, toWeekString } from '../../../helpers/moment';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../components/SweetAlert';
import Modal from 'react-modal';

const { API_URL } = config;

const CreditRewards = ({ activeClient, activeSite, activeWeek }) => {
  const padding = 90; // adjust this to your needs
  let height = 375 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const [showModal, setShowModal] = useState(false);
  const [list, setList] = useState('Loading...');
  const [applyBtn, setApplyBtn] = useState(true);

  const token = localStorage.getItem('token')
    ? localStorage.getItem('token')
    : null;

  const handleOpenModal = async () => {
    setShowModal(true);
    setList('Loading...');
    const url = `${API_URL}/reward/associate/schedule`;
    let response = await fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify({
        start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
        end_date: moment(activeWeek.endDate).format('YYYY-MM-DD'),
        site_id: activeSite.id,
      }),
      withCredentials: true,
      headers: {
        Authorization: token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    let data = await response.json();
    if (response.ok) {
      let display = '';
      let count = 1;

      if (
        data.result.weekdays.recordset.length > 0 ||
        data.result.weekends.recordset.length > 0 ||
        data.result.additional.recordset.length > 0
      ) {
        if (data.result.weekdays.recordset.length > 0) {
          display += '<h5>Weekdays:</h5>';
          data.result.weekdays.recordset.forEach((item) => {
            display += `<p style='font-size: 12px;'>${count}. ${
              item.shift_name
            } | ${moment(item.shift_date).format('YYYY-MM-DD')} - ${
              item.day
            } | ${item.shift_start}-${item.shift_end} | ${item.associate_id}-${
              item.ass_name
            } | ${item.points} </p>`;
            count++;
          });
        }

        if (data.result.weekends.recordset.length > 0) {
          display += '<br /><br />';
          display += '<h5>Weekends:</h5>';
          data.result.weekends.recordset.forEach((item) => {
            display += `<p style='font-size: 12px;'>${count}. ${
              item.shift_name
            } | ${moment(item.shift_date).format('YYYY-MM-DD')} - ${
              item.day
            } | ${item.shift_start}-${item.shift_end} | ${item.associate_id}-${
              item.ass_name
            } | ${item.points} </p>`;
            count++;
          });
        }

        if (data.result.additional.recordset.length > 0) {
          display += '<br /><br />';
          display += '<h5>Additional Rewards: Worked for more than 24hrs</h5>';
          data.result.additional.recordset.forEach((item) => {
            display += `<p style='font-size: 12px;'>${count}. ${
              item.associate_id
            }-${item.ass_name} | Total Shifts: ${
              item.total_shifts
            } | ${10} </p>`;
            count++;
          });
        }

        setApplyBtn(false);
      } else {
        display += `No records found.`;
      }

      setList(parse(display));
    }
  };
  const handleCloseModal = () => setShowModal(false);

  const applyRewards = async (e) => {
    e.preventDefault();
    setApplyBtn(true);
    const isConfirmed = await AlertService.confirm(
      '',
      `Are you sure you want to Apply Rewards for the Week ${toWeekInt(
        activeWeek.startDate,
        activeClient.start_day
      )} - ${toWeekString(activeWeek.endDate, activeClient.start_day)}?`
    );
    if (isConfirmed) {
      try {
        const url = `${API_URL}/reward/associate/schedule/apply`;
        setList('Loading...');
        let response = await fetch(url, {
          mode: 'cors',
          method: 'POST',
          body: JSON.stringify({
            start_date: moment(activeWeek.startDate).format('YYYY-MM-DD'),
            end_date: moment(activeWeek.endDate).format('YYYY-MM-DD'),
            site_id: activeSite.id,
          }),
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let data = await response.json();

        if (response.ok) {
          setApplyBtn(false);
          ToastUtil.success('Reward points applied successfully.');
          handleCloseModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <React.Fragment>
      {activeClient && activeWeek.startDate && activeSite && (
        <React.Fragment>
          <div
            className="adjust-card-shadow mb-4 px-4 d-flex flex-row justify-content-between align-items-center"
            style={{
              height: '120px',
              borderLeft: ' 10px solid #339900',
              marginRight: '1rem',
            }}
          >
            <div className="d-flex flex-column" style={{ width: '70%' }}>
              <h6 className="adjust-upload-title">Credit Rewards</h6>
              <p className="text-muted adjust-upload-description">
                This section be able to credit reward points.
              </p>
            </div>
            {/* <button type="button" disabled={(moment().day() !== 0) ? true : false} onClick={handleOpenModal} className="btn btn-outline-brand" style={{width: 150}}>Upload</button> */}
            <button
              type="button"
              disabled={false}
              onClick={handleOpenModal}
              className="btn btn-outline-brand adjust-btn-shadow px-4"
            >
              Open
            </button>
          </div>
          <Modal
            ariaHideApp={false}
            isOpen={showModal}
            style={{
              overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
              content: style,
            }}
          >
            <div className="pb-2">
              Week {toWeekInt(activeWeek.startDate, activeClient.start_day)}
            </div>
            <h6>
              {activeSite.name}: Apply Rewards from{' '}
              {toWeekString(activeWeek.endDate, activeClient.start_day)}
              &nbsp;&nbsp;
              <button
                type="button"
                disabled={applyBtn}
                onClick={applyRewards}
                className="btn btn-outline-brand"
                style={{ width: 100 }}
              >
                Apply
              </button>
              &nbsp;
              <button
                type="button"
                disabled={false}
                onClick={handleCloseModal}
                className="btn btn-outline-brand"
                style={{ width: 100 }}
              >
                Close
              </button>
            </h6>
            <br />
            <br />
            <div>{list}</div>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CreditRewards;
